import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_LEAGUE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'League',
        name: 'League',
        icon: 'fas fa-trophy',
        route: { name: ROUTE_NAME_LEAGUE.INDEX }
    }
]);

export default registerRouteForModule(router);
